import h from 'snabbdom/h';
import { play, pause } from './icons';
import marker from './marker';
import { getActiveColor, getHoverColor } from '../modules/player';
import { isPlaying, getTime, startPlaying, stopPlaying, getTimelineAnimation, setTime } from '../modules/animation';

let dragHandler = null;
let timeoutHandler = null;
let visible = false;

export default function timeline(store) {
  const timelineStyle = {
    flex: '1 1 auto',
    position: 'relative',
    bottom: 0,
    right: 0,
    borderRadius: '5px',
    padding: '0 20px',
  };

  const rulerStyle = {
    boxSizing: 'border-box',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    border: '1px solid #ccc',
    position: 'relative',
    top: '17px',
    left: '56px',
    height: '10px',
    width: 'calc(100% - 55px)',
    cursor: 'pointer',
  };

  const activeColor = getActiveColor(store);
  const hoverColor = getHoverColor(store);
  const iconAttrs = { width: 34, height: 34, title: 'play' };
  const iconOptions = { active: false, activeColor };

  const timeAnimation = getTimelineAnimation(store);
  if (!timeAnimation) return null;
  const startTime = timeAnimation.start;
  const duration = timeAnimation.duration / Math.abs(timeAnimation.playSpeed);
  const played = Math.max(Math.min((getTime(store) - startTime) / duration, 1), 0) * 100;

  const playedStyle = {
    backgroundColor: activeColor,
    width: 'calc(' + played + '% - 2px)',
    height: '6px',
    position: 'absolute',
    left: '1px',
    top: '1px',
    cursor: 'pointer',
  };

  const buttonStyle = {
    position: 'relative',
    display: 'inline-block',
    verticalAlign: 'middle',
    top: '-5px',
    cursor: 'pointer',
  };

  const hoverStyle = `
    div.claraplayer div div svg:hover path {
    fill: ${hoverColor};
  }`;

  function createHandleDrag({ width, left }, touch) {
    return (ev) => {
      visible = true;
      if (timeoutHandler) {
        window.clearTimeout(timeoutHandler);
      }

      timeoutHandler = window.setTimeout(function () {
        visible = false;
        store.dispatch({ type: 'POKE' });
      }, 2000);

      const evX = touch ? ev.touches[0].pageX : ev.pageX;
      const percentTime = Math.max(Math.min((evX - left) / width, 1), 0);
      const time = (percentTime) * duration + startTime;
      store.dispatch(setTime(time));
    };
  }

  function handleClick(ev) {
    //console.log(ev.target.parentNode);
    visible = true;
    if (timeoutHandler) {
      window.clearTimeout(timeoutHandler);
    }

    timeoutHandler = window.setTimeout(function () {
      visible = false;
      store.dispatch({ type: 'POKE' });
    }, 2000);

    if (dragHandler !== null) {
      window.removeEventListener('mousemove', dragHandler);
      window.removeEventListener('mouseup', endDrag);
      window.removeEventListener('touchmove', dragHandler);
      window.removeEventListener('touchend', endDrag);
    }

    const touch = !!ev.touches;
    const evX = touch ? ev.touches[0].clientX : ev.clientX;

    let rectElement = ev.target.className === 'ruler' ? ev.target : ev.target.parentNode;
    const rect = rectElement.getBoundingClientRect();

    const time = ((evX - rect.left) / rect.width) * duration + startTime;
    store.dispatch(setTime(time));

    dragHandler = createHandleDrag(rect, touch);
    if (!touch) {
      window.addEventListener('mousemove', dragHandler);
      window.addEventListener('mouseup', endDrag);
    } else {
      window.addEventListener('touchmove', dragHandler);
      window.addEventListener('touchend', endDrag);
    }
  }

  function endDrag(ev) {
    window.removeEventListener('mousemove', dragHandler);
    window.removeEventListener('mouseup', endDrag);
    window.removeEventListener('touchmove', dragHandler);
    window.removeEventListener('touchend', endDrag);
    dragHandler = null;
  }

  const icon = isPlaying(store) ? pause(iconAttrs, iconOptions) : play(iconAttrs, iconOptions);
  const clickAction = isPlaying(store) ? () => store.dispatch(stopPlaying()) : () => store.dispatch(startPlaying());

  return h('div', { style: timelineStyle }, [
    h('style', { props: { innerHTML: hoverStyle } }),
    h('div.ruler', { style: rulerStyle, on: { mousedown: handleClick, touchstart: handleClick } }, [
      h('div.played', { style: playedStyle }),
      marker(store, played, duration, visible),
    ]),
    h('div', { style: buttonStyle, on: { click: clickAction } }, [icon]),
  ]);
}



// WEBPACK FOOTER //
// ./src/components/timeline.js